<script setup lang="ts">
import type { StompClient } from "@/components/realtime/stom-client.ts";

import { ref, watch } from "vue";

import BackofficeStompClient from "@/components/realtime/backoffice-stomp-client.ts";
import { StompContext } from "@/components/realtime/stomp-context.ts";
import { useEnv } from "@/hooks/use-env";

interface Props {
  enabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  enabled: false,
});

const env = useEnv();
const stompClient = ref<StompClient>(new BackofficeStompClient(env));

watch(
  () => props.enabled,
  () => {
    if (props.enabled) {
      if (!stompClient.value.isActive) {
        stompClient.value.activate();
      }
    } else {
      if (stompClient.value.isActive) {
        stompClient.value.deactivate();
      }
    }
  },
  { immediate: true },
);
</script>

<template>
  <div>
    <StompContext.Provider :value="{ stompClient }">
      <slot></slot>
    </StompContext.Provider>
  </div>
</template>

<style scoped></style>
